import flocknoteStateHooks from "Flocknote/stateHooks";

import { useFamilyRegistrationContext } from "Signups/FamilyRegistration/FamilyRegistrationContext";
import IsClosedNetworkMessage from "Signups/FamilyRegistration/IsClosedNetworkMessage";
import { Stack } from "Signups/FamilyRegistration/Shared/StyledComponents";
import useFamilyRegistrationAdminPermissions, {
  useShouldHideFamRegSettings,
} from "Signups/FamilyRegistration/Shared/useFamilyRegistrationAdminPermissions";

import { FnrScreen } from "UI/FnrScreens";

import AccentColorTemporary from "./Settings/AccentColorTemporary";
import FNPMarketingBlurb from "./Settings/FNPMarketingBlurb";
import FamilyRegMarketingBlurb from "./Settings/FamilyRegMarketingBlurb";
import IntroductionMessage from "./Settings/IntroductionMessage";
import MembershipStatuses from "./Settings/MembershipStatuses";
import MembershipStatusAdminControls from "./Settings/MembershipStatuses/MembershipStatusAdminControls";
import NetworkFamilyRegistration from "./Settings/NetworkFamilyRegistration";

export default function WelcomePanel() {
  const {
    state: { selectedPanel, networkHasFamilyRegistration },
  } = useFamilyRegistrationContext();
  const shouldHideFamRegSettings = useShouldHideFamRegSettings();
  const isClosedNetwork = flocknoteStateHooks.useIsClosedNetwork();

  const {
    shouldSeparateMembershipStatusSection,
    shouldShowFNPMarketingBlurb,
    shouldShowFamilyRegistrationBlurb,
  } = useFamilyRegistrationAdminPermissions();

  return (
    <FnrScreen show={selectedPanel === "welcome"} side="left">
      <Stack>
        {shouldShowFNPMarketingBlurb && <FNPMarketingBlurb />}
        {!shouldHideFamRegSettings && (
          <>
            {networkHasFamilyRegistration ? (
              <NetworkFamilyRegistration />
            ) : null}

            {shouldShowFamilyRegistrationBlurb && <FamilyRegMarketingBlurb />}

            <IntroductionMessage />

            <AccentColorTemporary />

            {/* <AccentColor /> */}
            <MembershipStatuses />
          </>
        )}
        {isClosedNetwork && <IsClosedNetworkMessage />}
        {shouldSeparateMembershipStatusSection && (
          <MembershipStatusAdminControls />
        )}
      </Stack>
    </FnrScreen>
  );
}
